<template>
    <div class="table-responsive invoice-table" id="table">
        <table class="table table-bordered table-striped">
            <tbody>
                <tr>
                    <td class="item">
                        <h4 class="p-2 mb-0">Item Description</h4>
                    </td>
                    <td class="Hours">
                        <h4 class="p-2 mb-0">Hours</h4>
                    </td>
                    <td class="Rate">
                        <h4 class="p-2 mb-0">Rate</h4>
                    </td>
                    <td class="subtotal">
                        <h4 class="p-2 mb-0">Sub-total</h4>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Brown Dress</label>
                        <p class="m-0">Aask - Brown Polyester Blend Women's Fit & Flare Dress.</p>
                    </td>
                    <td>
                        <p class="itemtext digits">5</p>
                    </td>
                    <td>
                        <p class="itemtext digits">$75</p>
                    </td>
                    <td>
                        <p class="itemtext digits">$375.00</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Red Shirt</label>
                        <p class="m-0">Wild West - Red Cotton Blend Regular Fit Men's Formal Shirt.</p>
                    </td>
                    <td>
                        <p class="itemtext digits">3</p>
                    </td>
                    <td>
                        <p class="itemtext digits">$75</p>
                    </td>
                    <td>
                        <p class="itemtext digits">$225.00</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Flower Dress</label>
                        <p class="m-0">Skyblue Flower Printed Sleevless Strappy Dress.</p>
                    </td>
                    <td>
                        <p class="itemtext digits">10</p>
                    </td>
                    <td>
                        <p class="itemtext digits">$75</p>
                    </td>
                    <td>
                        <p class="itemtext digits">$750.00</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Red Skirt</label>
                        <p class="m-0">R L F - Red Cotton Blend Women's A-Line Skirt.</p>
                    </td>
                    <td>
                        <p class="itemtext digits">10</p>
                    </td>
                    <td>
                        <p class="itemtext digits">$75</p>
                    </td>
                    <td>
                        <p class="itemtext digits">$750.00</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p class="itemtext"></p>
                    </td>
                    <td>
                        <p class="m-0">HST</p>
                    </td>
                    <td>
                        <p class="m-0 digits">13%</p>
                    </td>
                    <td>
                        <p class="m-0 digits">$419.25</p>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td class="Rate">
                        <h6 class="mb-0 p-2">Total</h6>
                    </td>
                    <td class="payment digits">
                        <h6 class="mb-0 p-2">$3,644.25</h6>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>